export default __webpack_public_path__ + "db6e80657642434451cc1bf88ee291a8.png";